import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { DashboardRoutes } from "./dashboard.routing";
import { DashboardComponent } from "./dashboard.component";
import { MaterialModule } from "../material.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TopSendersComponent } from "./charts/top-senders/top-senders.component";
import { OpensViewsComponent } from "./charts/opens-views/opens-views.component";
import { NgChartsModule } from "ng2-charts";
import { StatsComponent } from "./stats/stats.component";
import { TeamResultsComponent } from "./team-results/team-results.component";
import { UsersUsageComponent } from "./charts/users-usage/users-usage.component";
import { ReactionPipe } from "../pipes/reaction.pipe";
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { GlobalLeaderboardComponent } from './leaderboard/global-leaderboard/global-leaderboard.component';
import { OrgLeaderboardComponent } from './leaderboard/org-leaderboard/org-leaderboard.component';
import { RankComponent } from './rank/rank.component';
import { GuruBadgeDialogComponent } from './rank/guru-badge-dialog/guru-badge-dialog.component';
import { UserStreakComponent } from "./streaks/user-streak/user-streak.component";

@NgModule({
  declarations: [
    DashboardComponent,
    TopSendersComponent,
    OpensViewsComponent,
    StatsComponent,
    TeamResultsComponent,
    UsersUsageComponent,
    ReactionPipe,
    LeaderboardComponent,
    GlobalLeaderboardComponent,
    OrgLeaderboardComponent,
    RankComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FontAwesomeModule,
    NgChartsModule,
    UserStreakComponent,
    GuruBadgeDialogComponent,
    RouterModule.forChild(DashboardRoutes),
  ],
})
export class DashboardModule {}
